import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';
import 'swiper/css';
import { domContentLoadEvent } from '../common/domContentLoadEvent';

function initialize(testmonialsElement) {
    const swiperPagination = testmonialsElement.querySelector('.swiper-pagination');
    const progressBar = testmonialsElement.querySelector('.swiper-pagination');

    new Swiper(testmonialsElement.querySelector('.swiper'), {
        modules: [Pagination, Navigation, Autoplay],
        slidesPerView: 1,
        loop: true,
        spaceBetween: 20,

        breakpoints: {
            320: {
                spaceBetween: 20,
            },
        },

        autoplay: {
            delay: 15000,
            disableOnInteraction: false,
        },

        navigation: {
            nextEl: '.testmonial-swiper-button-next',
            prevEl: '.testmonial-swiper-button-prev',
        },

        pagination: {
            el: swiperPagination,
            clickable: true,
            renderBullet: function (index, className) {
                return (
                    '<span class="swiper-pagination-bullet">' +
                    ' <span>' +
                    (index + 1).toString().padStart(2, '0') +
                    '</span>' +
                    ' <div class="progress"><span class="progress-bar"></span></div> ' +
                    '</span>'
                );
            },
        },
        on: {
            autoplayTimeLeft(s, time, progress) {
                progressBar.style.setProperty('--progress', Math.max(Math.min(1 - progress,1),0));
            },
        },
    });
}

function initializeAll() {
    document.querySelectorAll('.sectionTestmonial').forEach(function (element) {
        initialize(element);
    });
}

domContentLoadEvent(initializeAll);
